/* GL Oct 28 2026. Quick view polish, matching the product page.
   - Order: title, star rating, price, wishlist link, then the form.
   - Growave's red-heart wishlist button is hidden; a quiet gold-underlined "Add to wishlist" link drives it
     (same behaviour as snippets/gl-wishlist-link.liquid on product pages).
   - Full-width "Add to my collection" button, and a link to the full product page for sizes and room views.
   Loaded by sections/gl-mood-row.liquid (collections) and sections/gl-search-main.liquid (search),
   via snippets/gl-quickview-config.liquid.
   Oct 29 2026: wording, colours and on/off switches come from Customize > Theme settings > GL quick view,
   passed as window.GLQV; the original values remain as fallbacks. */
(function () {
  var C = window.GLQV || {};
  function c(k, d) { var v = C[k]; return (v === undefined || v === null || v === '') ? d : v; }
  function on(k) { return C[k] !== false; }
  var ACC = c('accent', '#CBBD6D'), BG = c('btn_bg', '#1F1F1F'), BGH = c('btn_hover', '#000000'), FG = c('btn_text', '#ffffff');
  var css = document.createElement('style');
  css.textContent =
    '.gl-wl-hidden{position:absolute !important;width:1px !important;height:1px !important;overflow:hidden !important;clip:rect(0 0 0 0) !important;white-space:nowrap !important}' +
    '.quick-shop__lightbox .gl-wl{display:inline-block;margin:4px 0 14px;padding:10px 0;font-size:13px;line-height:1.2;letter-spacing:.12em;text-transform:uppercase;color:#2b2b2b;text-decoration:underline;text-decoration-color:' + ACC + ';text-decoration-thickness:1px;text-underline-offset:6px}' +
    '.quick-shop__lightbox .gl-wl:hover{text-decoration-color:#2b2b2b}' +
    '.quick-shop__lightbox .gl-wl:focus-visible{outline:2px solid ' + ACC + ';outline-offset:3px}' +
    '.quick-shop__lightbox .product-block--price{margin-top:2px}' +
    (on('btn_style') ? '.quick-shop__lightbox .button--add-to-cart{' + (on('btn_full') ? 'width:100% !important;max-width:none !important;' : '') + 'min-height:' + c('btn_height', 56) + 'px;font-size:15px;letter-spacing:.14em;background:' + BG + ' !important;border-color:' + BG + ' !important;color:' + FG + ' !important}' +
    '.quick-shop__lightbox .button--add-to-cart:hover{background:' + BGH + ' !important}' : '') +
    '.quick-shop__lightbox .gl-qv-more{display:inline-block;margin-top:18px;font-size:14px;letter-spacing:.06em;color:#1A1A1A;text-decoration:underline;text-underline-offset:4px;font-weight:600}';
  document.head.appendChild(css);

  function deep(root, out) {
    root.querySelectorAll('*').forEach(function (el) { out.push(el); if (el.shadowRoot) deep(el.shadowRoot, out); });
    return out;
  }
  function trigger(block) {
    var els = deep(block, []);
    for (var i = 0; i < els.length; i++) if (els[i].matches('button, [role="button"], a')) return els[i];
    return els[0] || null;
  }
  function savedIn(block) {
    return deep(block, []).some(function (el) {
      var c = (typeof el.className === 'string' ? el.className : '') + ' ' + (el.getAttribute('aria-pressed') || '');
      return /\b(active|added|selected|in-wishlist|is-fav\w*|faved|true)\b/i.test(c) || /added|remove from|in your wishlist/i.test(el.getAttribute('aria-label') || '');
    });
  }
  function isFr() { return (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0; }

  function polish(info) {
    if (info.dataset.glQv) return;
    var title = info.querySelector('.product-block--title');
    var price = info.querySelector('.product-block--price');
    var apps = info.querySelectorAll('.product-block--\\@app');
    if (!title || !price || apps.length < 1) return;
    info.dataset.glQv = '1';

    var reviews = null, fave = null;
    apps.forEach(function (b) {
      var html = (b.innerHTML || '').toLowerCase();
      if (!fave && /fave|wishlist/.test(html) && !/review/.test((b.textContent || '').toLowerCase())) fave = b;
      else if (!reviews) reviews = b;
    });
    if (!fave && apps.length > 1) fave = apps[1];
    if (reviews === fave) reviews = null;

    if (on('reorder')) {
      if (reviews) title.parentNode.insertBefore(reviews, title.nextSibling);
      var anchor = reviews ? reviews : title;
      anchor.parentNode.insertBefore(price, anchor.nextSibling);
    }

    if (fave && on('wishlist')) {
      var fr = isFr();
      var link = document.createElement('a');
      link.className = 'gl-wl';
      link.href = c('wl_page', '/pages/wishlist');
      var saved = false;
      var render = function () {
        link.textContent = saved ? c('wl_added', fr ? 'Ajout\u00e9 \u00e0 la liste' : 'Added to wishlist') : c('wl_add', fr ? 'Ajouter \u00e0 ma liste' : 'Add to wishlist');
        link.setAttribute('aria-label', saved ? 'Added to wishlist. Open your wishlist' : 'Add this work to your wishlist');
        if (saved) { try { localStorage.setItem('glWlSaved', '1'); } catch (e) {} window.dispatchEvent(new Event('gl:wishlist')); }
      };
      link.addEventListener('click', function (e) {
        if (saved) return;
        e.preventDefault();
        var t = trigger(fave); if (t) t.click();
        saved = true; render();
      });
      fave.classList.add('gl-wl-hidden');
      price.parentNode.insertBefore(link, price.nextSibling);
      saved = savedIn(fave); render();
      [600, 1800, 4000].forEach(function (ms) { setTimeout(function () { if (!saved && savedIn(fave)) { saved = true; render(); } }, ms); });
    }

    var box = info.closest('.quick-shop__lightbox');
    var m = box && String(box.className).match(/product-(\d+)/);
    var href = null;
    var a = info.querySelector('a[href*="/products/"]');
    if (a) href = a.getAttribute('href').split('?')[0];
    if (!href && m) {
      var card = document.querySelector('.product-' + m[1] + ' a[href*="/products/"], .product__grid-item.product-' + m[1] + ' a[href*="/products/"]');
      if (card) href = card.getAttribute('href').split('?')[0];
    }
    var form = info.querySelector('.product-block--form');
    if (on('more') && href && form && !info.querySelector('.gl-qv-more')) {
      var more = document.createElement('a');
      more.className = 'gl-qv-more';
      more.href = href;
      more.textContent = c('more_text', isFr() ? 'Voir tous les d\u00e9tails, formats et la mise en sc\u00e8ne \u2192' : 'See full details, all formats and room view \u2192');
      form.appendChild(more);
    }
  }

  function scan() {
    document.querySelectorAll('.quick-shop__lightbox .product__information').forEach(polish);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
